// quick-view.js — Phase 1.3 (jm-2.0.0)
// Extracted from theme.js: QuickView (base), ButtonQuickView, ButtonSelectOptions.
// All guarded with customElements.get(). Depends on PopupBase (global.js).

if (!customElements.get('button-quickview')) {
  class QuickView extends PopupBase {
    constructor() {
      super();
      this.html = null;
    }

    onThisClick() {
      this.classList.add("loading");
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          this.html = (typeof parser !== 'undefined' ? parser : new DOMParser())
            .parseFromString(text, "text/html")
            .querySelector(
              "#shopify-section-product-quickview .product-quickview__content"
            );
          if (!this.html) return;
          // Load scripts in the HTML content
          this.loadScripts(this.html);
          this.html.classList.remove("hidden");
          this.initPopup(this.html);
          this.bindQuickviewMediaLinks(this.html);
        })
        .finally(() => {
          if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) Shopify.PaymentButton.init();
          if (!document.querySelector('div[data-animation="slide_in"')) {
            BlsLazyloadImg.init();
          }
          // JM: Trigger module scan for dynamically inserted quickview content
          if (window.theme && window.theme.scanModules) {
            window.theme.scanModules();
          }
          const qvRoot = this.html;
          if (qvRoot) {
            qvRoot
              .querySelectorAll(
                "variant-radios-detail, variant-group-detail"
              )
              .forEach((picker) => {
                if (picker.bootstrapPurchasableVariant) {
                  picker.bootstrapPurchasableVariant();
                  if (picker.refreshVariantPickerAvailability) {
                    requestAnimationFrame(() =>
                      picker.refreshVariantPickerAvailability()
                    );
                  }
                }
              });
          }
          // JM: Update Swiper after modal is visible so it recalculates dimensions.
          // The slide-with-thumbs constructor fires during setContent() when the
          // modal is still invisible → Swiper gets zero-width → slides stack vertically.
          const _qv = this;
          setTimeout(function () {
            const modalEl = _qv.modal && _qv.modal.modal;
            if (!modalEl) return;
            const slider = modalEl.querySelector('slide-with-thumbs');
            if (slider && slider.globalSlide) {
              slider.globalSlide.update();
            }
          }, 200);
          this.classList.remove("loading");
        })
        .catch((e) => {
          this.classList.remove("loading");
          console.error(e);
        });
    }

    bindQuickviewMediaLinks(root) {
      if (!root || root.dataset.quickviewImageNavigationBound === "true") return;
      const productUrl =
        root.dataset.productUrl ||
        root
          .querySelector(".product-singe__view-all-button")
          ?.getAttribute("href");
      if (!productUrl) return;

      const slides = root.querySelectorAll(
        ".media-main-swiper .media-gallery__image"
      );
      if (!slides.length) return;

      const productTitle = (root.dataset.productTitle || "").trim();
      const ariaLabel = productTitle
        ? `Produktseite öffnen: ${productTitle}`
        : "Produktseite öffnen";

      slides.forEach((slide) => {
        slide.dataset.quickviewImageLink = "true";
        slide.setAttribute("role", "link");
        slide.setAttribute("tabindex", "0");
        slide.setAttribute("aria-label", ariaLabel);
      });

      root.addEventListener("click", (event) => {
        const target = event.target.closest("[data-quickview-image-link]");
        if (!target) return;
        event.preventDefault();
        window.location.href = productUrl;
      });

      root.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        const target = event.target.closest("[data-quickview-image-link]");
        if (!target) return;
        event.preventDefault();
        window.location.href = productUrl;
      });

      root.dataset.quickviewImageNavigationBound = "true";
    }

    loadScripts(html) {
      const scripts = html.querySelectorAll("script");
      scripts.forEach((script) => {
        const newScript = document.createElement("script");
        newScript.src = script.src;
        newScript.textContent = script.textContent;
        document.body.appendChild(newScript).parentNode.removeChild(newScript);
      });
    }
  }

  class ButtonQuickView extends QuickView {
    constructor() {
      super();
      this.url = this.dataset.url;
      // Stabile gebundene Referenz, damit init() idempotent ist und
      // Re-Mounts (z.B. nach product-recommendations innerHTML-Inject auf
      // der PDP) den Click-Listener nicht doppelt registrieren.
      this.onBtnClick = this.onThisClick.bind(this);
      this.init();
    }

    init() {
      if (this._qvBound) return;
      this._qvBound = true;
      this.addEventListener("click", this.onBtnClick);
    }

    // Re-mount kann passieren, wenn die enthaltende Section per AJAX
    // ihren innerHTML neu setzt (z.B. <product-recommendations> auf der
    // Produktseite). Constructor laeuft dann eventuell nicht — daher
    // bindet connectedCallback defensiv (idempotent).
    connectedCallback() {
      if (super.connectedCallback) super.connectedCallback();
      if (!this.url) this.url = this.dataset.url;
      if (!this.onBtnClick) this.onBtnClick = this.onThisClick.bind(this);
      this.init();
    }
  }
  customElements.define("button-quickview", ButtonQuickView);

  class ButtonSelectOptions extends QuickView {
    constructor() {
      super();
      this.url = this.dataset.url;
      this.onBtnClick = this.onThisClick.bind(this);
      this.init();
    }

    init() {
      if (this._qvBound) return;
      this._qvBound = true;
      this.addEventListener("click", this.onBtnClick);
    }

    connectedCallback() {
      if (super.connectedCallback) super.connectedCallback();
      if (!this.url) this.url = this.dataset.url;
      if (!this.onBtnClick) this.onBtnClick = this.onThisClick.bind(this);
      this.init();
    }
  }
  if (!customElements.get('select-option')) {
    customElements.define("select-option", ButtonSelectOptions);
  }
}
